// No URL queries or user input are sent; only immutable bundle/update identifiers.
export function productRelease() {
    try {
        const runtime = JSON.parse(localStorage.getItem('pill_reminder_app_runtime_info') || '{}');
        const script = [...document.scripts].map(s => s.src).find(src => /\/main\.[a-zA-Z0-9]+\.js(?:$|\?)/.test(src));
        const webRelease = script?.match(/\/main\.([a-zA-Z0-9]+)\.js/)?.[1] || (process.env.NODE_ENV !== 'production' ? 'dev' : 'unknown');
        const nativeUpdate = runtime.updateId || (runtime.isEmbeddedLaunch ? 'embedded' : 'unknown');
        return { webRelease, nativeUpdate: /^[a-zA-Z0-9_.-]{1,80}$/.test(nativeUpdate) ? nativeUpdate : 'unknown' };
    } catch { return { webRelease: 'unknown', nativeUpdate: 'unknown' }; }
}
